export enum SuppliersBalanceFilterType {
  Account = 'account',
  BalanceDirection = 'balanceDirection',
}
